export default "__VITE_ASSET__Cvvhu0sG__"